import { newSize } from '@lessonup/pins-shared';

// Sizes for the StudentJoin and Ranking screens, these will get scaled
export const playerScreenSize = newSize(960, 540);
